import { Injectable } from '@angular/core';
import {DeviceLocation, DeviceLocationList} from './device_location';
import {BaseService} from '../base/base.service';
import {DeviceLocationSerializer} from 'src/app/device_locations/device_location.serializer';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DeviceLocationService extends BaseService<DeviceLocation, DeviceLocationList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'device_locations' ;
    this.serializer = new DeviceLocationSerializer();
  }
}
